import PageHeader from "../common/pageHeader/v2";
import Transactions from "../components/section/services/transactions";
import Features from "../components/section/services/features";

const ServicesPage = () => {
  return (
    <>
      <PageHeader title="services" subTitle="services" />
      <Features />
      <Transactions />
    </>
  );
};

export default ServicesPage;
